import apiClient from './api.service';

const PaymentService = {
  // Get all payments
  getAllPayments() {
    return apiClient.get('/payment');
  },

  // Get payment by ID
  getPaymentById(id) {
    return apiClient.get(`/payment/${id}`);
  },

  // Get payments by user
  getPaymentsByUser(userId) {
    return apiClient.get(`/payment/byUser/${userId}`);
  },

  // Get payments by course
  getPaymentsByCourse(courseId) {
    return apiClient.get(`/payment/byCourse/${courseId}`);
  },

  // Bank-transfer (IBFT) payments: confirm (counts as paid) or reject (access removed)
  confirmIbft(paymentId) {
    return apiClient.post(`/payment/admin/ibft/${paymentId}/confirm`);
  },

  rejectIbft(paymentId) {
    return apiClient.post(`/payment/admin/ibft/${paymentId}/reject`);
  },

  // Verify payment
  verifyPayment(paymentId, data) {
    return apiClient.post(`/payment/admin/verify/${paymentId}`, data);
  },

  // Process refund
  processRefund(paymentId, refundData) {
    return apiClient.post(`/payment/admin/refund/${paymentId}`, refundData);
  },

  // Get payment statistics
  getPaymentStats(startDate, endDate) {
    return apiClient.get('/payment/admin/stats', {
      params: { startDate, endDate }
    });
  },

  // Get revenue report
  getRevenueReport(period) {
    return apiClient.get('/payment/admin/revenue', {
      params: { period }
    });
  }
};

export default PaymentService;
